/**
 * Tabs module to create a tab system.
 */
const tabs = document.querySelectorAll('.tabs');
if (typeof tabs !== 'undefined' && tabs.length > 0) {
  // Convert NodeList to Array.
  const tabBlocks = [...tabs];

  tabBlocks.forEach(tabBlock => {
    const tabsContent = [...tabBlock.querySelectorAll('.tabs-content')];
    const tabsNav = tabBlock.querySelector('.tabs-nav');

    // Add active class to first tab content and nav item.
    tabsNav.children[0].classList.add('tabs--active');
    tabsContent[0].classList.add('tabs--active');

    // Add an event listener to change active class.
    tabsNav.addEventListener('click', e => {
      e.preventDefault();

      // Grab the selected tab element.
      const selectedTab = e.target;

      // Handle only navLink elements.
      if (!selectedTab.classList.contains('tabs-navLink')) {
        return;
      }

      // Remove all active classes from the navItems.
      [...tabsNav.querySelectorAll('.tabs-navItem')].forEach(navItem => {
        navItem.classList.remove('tabs--active');
      });

      // Remove active from all tabs
      tabsContent.forEach(tab => {
        tab.classList.remove('tabs--active');
      });

      // Add the active class to the selected tab block.
      const selectedTabId = selectedTab.getAttribute('data-tab-id');
      const selectedNavItem = tabsNav.querySelector(`[data-tab-id="${selectedTabId}"]`);
      const selectedTabBlock = tabBlock.querySelector(`[data-tab="${selectedTabId}"]`);
      selectedNavItem.parentElement.classList.add('tabs--active');
      selectedTabBlock.classList.add('tabs--active');
    });
  });
}
